export default "__VITE_ASSET__CZtAY8$K__"